export default "__VITE_ASSET__9a4a26b9__"